import { ICompanyServiceDesk } from "@/api/AppApi/services/company/interfaces/ICompany";
import Flag from "@/app/components/lib/Flag";

export interface Props {
  serviceDesk: ICompanyServiceDesk;
}
const CustomersServiceBox: React.FC<Props> = ({ serviceDesk }) => {
  return (
    <div className="customers-service-box">
      <div className="customers-country">
        <Flag countryCode={serviceDesk?.iso2} width={28} />
        {serviceDesk.name}
      </div>
      <div className="customers-phone">
        <bdi>{serviceDesk.mobile}</bdi>
      </div>
    </div>
  );
};

export default CustomersServiceBox;
